// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { MedicalCardFinderAddressRequest } from './medicalCardFinderAddressRequest.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalCardFinderPatientRequest {
    'firstName': string;
    'middleName'?: string;
    'lastName': string;
    'dateOfBirth': Moment;
    'address': MedicalCardFinderAddressRequest | null;
    'phone'?: string;
    'suffix'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalCardFinderPatientRequest>> = [
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "middleName",
            "baseName": "middleName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "dateOfBirth",
            "baseName": "dateOfBirth",
            "type":     "Date"
        },
        {
            "name":     "address",
            "baseName": "address",
            "type":     "MedicalCardFinderAddressRequest"
        },
        {
            "name":     "phone",
            "baseName": "phone",
            "type":     "string"
        },
        {
            "name":     "suffix",
            "baseName": "suffix",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalCardFinderPatientRequest.attributeTypeMap;
    }
}
